// extracted by mini-css-extract-plugin
export default {"page":"AuthPage_page__H0ipZ"};